import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const AuctionHouseContainer = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 500;
  margin-bottom: 4px;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: #007bff;
  }
  
  .auction-text {
    flex: 1;
    min-width: 0;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.2;
  }
  
  .arrow-icon {
    font-size: 14px;
    color: #999;
    flex-shrink: 0;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

interface AuctionHouseProps {
  auctioneerName: string;
  auctioneerIndex: number;
  className?: string;
}

const AuctionHouse: React.FC<AuctionHouseProps> = ({
  auctioneerName,
  auctioneerIndex,
  className
}) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // 부모 요소의 클릭 이벤트 방지
    navigate(`/auctioneer/${auctioneerIndex}`);
  };

  return (
    <AuctionHouseContainer className={className} onClick={handleClick}>
      <span className="auction-text">{auctioneerName}</span>
      <span className="arrow-icon">›</span>
    </AuctionHouseContainer>
  );
};

export default AuctionHouse;
